var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81152 20V12.128H11.8915V20H9.81152ZM9.81152 11.184V9.24805H11.8915V11.184H9.81152Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1391 20V15.232C18.1391 14.624 18.0378 14.2134 17.8351 14C17.6325 13.7867 17.2858 13.68 16.7951 13.68C15.7178 13.68 15.1791 14.2827 15.1791 15.488V20H13.0991V12.128H15.0831V13.28C15.3285 12.832 15.6538 12.496 16.0591 12.272C16.4645 12.0374 16.9871 11.92 17.6271 11.92C18.0005 11.92 18.3471 11.9787 18.6671 12.096C18.9871 12.2027 19.2591 12.368 19.4831 12.592C19.7178 12.816 19.8991 13.0934 20.0271 13.424C20.1658 13.744 20.2351 14.1174 20.2351 14.544V20H18.1391Z",
    fill: "#E6E6E6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 26,
    height: 26,
    rx: 4,
    stroke: "#E6E6E6",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b3b6f05cfedd5eff9ce91fcf0084490a.svg";
export { ForwardRef as ReactComponent };